







import { Component, mixins } from '@niknevis/vue-modules'
import { FilterEntitySearchMixin } from '@/modules/common/filter/mixins/filterEntitySearchMixin'
import PersonSearch from '@/modules/common/person/components/PersonSearch.vue'

@Component({
  components: {
    PersonSearch
  }
})
export default class PersonSearchFilter extends mixins(FilterEntitySearchMixin) {
}
